export const copyContent = (targ, btn, inp) => {
    $(targ).on('click touchstart', btn, function () {
        const sp = $(this).find(inp);
        sp.focus();
        sp.select();
        document.execCommand('copy');
        $(this).find('.copy-link-icon').fadeOut(600).fadeIn(900);
        $(this).find('.copyed-link-icon').fadeIn(600).fadeOut(900);
    });
}
